import { Component } from '@angular/core';

@Component({
    selector: 'app-check-activities-section',
    templateUrl: './check-activities-section.component.html',
    styleUrls: ['./check-activities-section.component.scss'],
})
export class CheckActivitiesSectionComponent {
}
